import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		apiBaseUrl:'https://swello-christmas-game.osc-secnum-fr1.scalingo.io'
	}
});

export default app;